module.exports = __webpack_public_path__ + "static/media/il.2ed461d2.svg";